export default __webpack_public_path__ + "static/Montserrat-Bold-c4adaa9afbc79b3fc25e9a5b8e64d8ab.woff2";